import { render, staticRenderFns } from "./priceSteps.vue?vue&type=template&id=6d0fb1c8&scoped=true&"
import script from "./priceSteps.vue?vue&type=script&lang=js&"
export * from "./priceSteps.vue?vue&type=script&lang=js&"
import style0 from "./priceSteps.vue?vue&type=style&index=0&id=6d0fb1c8&lang=scss&scoped=true&"
import style1 from "./priceSteps.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0fb1c8",
  null
  
)

export default component.exports